export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 18.222a6.222 6.222 0 100-12.444 6.222 6.222 0 000 12.444zM12 20a8 8 0 100-16 8 8 0 000 16z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};